import React from "react";
import "./Extraction.css";

const Extraction = () => {
  return (
    <div className="extraction">
      <div className="extraction__container">
        <div className="extraction__left">
          <img
            src="images/puzzle-piece.png"
            alt="ai"
            style={{ width: "400px", height: "350px" }}
            className="extraction__img"
          />
        </div>
        <div className="extraction__right">
          <h1 className="extraction__title">Knowledge Extraction</h1>
          <p className="extraction__text">
            Knowledge Extraction is a new service that uses generative AI to
            extract knowledge from unstructured text. It can be used to extract
            key information from documents, such as contracts, invoices, and
            emails. It can also be used to extract{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Extraction;
